import React from 'react';
import Blog from '../components/Blog';

const BlogPage: React.FC = () => {
  return (
    <div className="pt-20">
      <Blog />
    </div>
  );
};

export default BlogPage;

